import styles from './Header.module.css'

export default function HeaderBack() {

    return <div className={styles.Header}>
        <a href="/" className={styles.Back}>←</a>
        <a href="/">Nico Dreher, Digital Product Designer</a>
    </div>
}
